// extracted by mini-css-extract-plugin
module.exports = {"list":"aed17b9412--list--IG_Xk","tablet":"aed17b9412--tablet--yLuGg","desktop":"aed17b9412--desktop--nNwav"};